// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../log-in-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-suggestions{border-radius:5px;border:1px solid #aaa;box-shadow:8px 8px 8px grey;z-index:1000}.custom-suggestion-item{border-bottom:1px solid #aaa;padding:.5em;cursor:pointer}.custom-suggestion-item.selected{background-color:#003c71;color:#fff}.custom-suggestion-item.hover{background-color:#2c5bc5;color:#fff}.icon-color{color:#003c71}.age-select{width:70px}.custom-radio{margin-left:20px}", ""]);
// Exports
module.exports = exports;
